import { Channel, Topic } from "../constants/index.js";
import { MessageBrokerUtils } from "../utils/index.js";
import { UIActionCreators } from "../redux/action-creators/index.js";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

export const useClientInitialization = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const subscription = MessageBrokerUtils.subscribe({
      channel: Channel.SESSION,
      topic: Topic.clientInitSucceeded,
      callback: () => {
        dispatch(UIActionCreators.setClientInitialized());
        subscription?.unsubscribe();
      }
    });
  }, [dispatch]);
};
